<script setup lang="ts">
    import { type NavItem, type SharedData } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import axios from 'axios';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        item: NavItem;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const normalizeUrl = (url: string): string => {
        try {
            return /^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : `${window.location.protocol}//${url}`;
        } catch (e) {
            return url;
        }
    };

    const handleClick = async () => {
        if (!selectedCompanyId.value) {
            toast.error(t('menu.choose_client'));
            return;
        }

        try {
            const response = await axios.post(props.item.href, {
                company_id: selectedCompanyId.value,
            });

            if (response.data?.url) {
                const url = normalizeUrl(response.data.url as string);
                window.location.assign(url);
                return;
            }

            if (response.data?.redirect) {
                const url = normalizeUrl(response.data.redirect as string);
                window.location.assign(url);
                return;
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.errors) {
                const firstError = Object.values(error.response.data.errors)[0];
                toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
            } else {
                toast.error(error.response?.data?.message || t('forms.system_error'));
            }
        }
    };
</script>

<template>
    <button
        @click.prevent.stop="handleClick"
        type="button"
        class="cursor-pointer"
    >
        <slot />
    </button>
</template>
